import React from 'react';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { useI18n } from 'i18n';
import Head from 'src/components/Head';
import Layout from 'src/components/Layout';
import A from 'src/components/A';

export default function Support(): React.ReactElement {
  const { t } = useI18n();

  return (
    <>
      <Head title={t('support-title')} description={t('support-description')} />
      <Layout>
        <Typography variant="h6" component="h3" sx={{ p: 4, paddingBottom: 0, paddingLeft: 0 }}>
          {t('support')}
        </Typography>
        <Typography variant="h4" component="h1" sx={{ pb: 4 }}>
          {t('support-top')}
        </Typography>
        <Paper sx={{ mb: 4 }}>
          <Grid container spacing={3} justifyContent="space-around">
            <Grid item xs={12} sm={4}>
              <Link href="/docs/basic-flow" passHref>
                <A>
                  <Paper
                    sx={{
                      m: 4,
                      p: 2,
                      textAlign: 'center',
                      backgroundColor: (theme) => theme.palette.primary.main,
                      color: (theme) => theme.palette.getContrastText(theme.palette.primary.main),
                    }}
                  >
                    {t('how-to-use')}
                  </Paper>
                </A>
              </Link>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Link href="/docs/energyplus" passHref>
                <A>
                  <Paper
                    sx={{
                      m: 4,
                      p: 2,
                      textAlign: 'center',
                      backgroundColor: (theme) => theme.palette.primary.main,
                      color: (theme) => theme.palette.getContrastText(theme.palette.primary.main),
                    }}
                  >
                    {t('technical-info')}
                  </Paper>
                </A>
              </Link>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Link href="https://baues.io/About" passHref>
                <A>
                  <Paper
                    sx={{
                      m: 4,
                      p: 2,
                      textAlign: 'center',
                      backgroundColor: (theme) => theme.palette.primary.main,
                      color: (theme) => theme.palette.getContrastText(theme.palette.primary.main),
                    }}
                  >
                    {t('about-baues')}
                  </Paper>
                </A>
              </Link>
            </Grid>
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <Link href="https://baues.io/contact" passHref>
              <A>
                <Typography variant="h6" component="h2" sx={{ p: 4 }}>
                  {t('support-form')}
                </Typography>
              </A>
            </Link>
          </Grid>
        </Paper>
      </Layout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
